import styled from "styled-components"

export const CssH0 = styled.h1`
	font-style: normal;
	font-weight: 600;
	font-size: 48px;
	line-height: 61px;

	@media (max-width: 500px) {
		font-size: 24px;
		margin-bottom: 20px;
	}
`

export const CssH1 = styled.h1`
	font-style: normal;
	font-weight: 600;
	font-size: 32px;
	line-height: 40px;

	@media (max-width: 500px) {
		font-size: 24px;
		margin-bottom: 20px;
	}
`

export const CssH2 = styled.h2`
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 30px;

	@media (max-width: 500px) {
		font-size: 18px;
	}
`
export const CssH3 = styled.h3`
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	line-height: 23px;

	@media (max-width: 500px) {
		font-size: 16px;
	}
`

export const CssH4 = styled.h4`
	font-style: normal;
	font-weight: 600;

	font-size: 16px;
	line-height: 20px;
`

export const CssP = styled.p`
	font-style: normal;
	font-weight: 400;

	font-size: 14px;
	line-height: 14px;
`
